import ApiClient from '@package/services/src/ApiClient';
import Result, { EmptyResult } from '@package/services/src/Result';

import { PayPalPaymentService } from './services';
import { PayPalAuthorizeRequest, PayPalCheckoutRequest, PayPalCheckoutResponse } from './types';

export default class PayPalPaymentApiService implements PayPalPaymentService {
  constructor(private readonly apiClient: ApiClient) {}

  public async paypalCheckout(
    request: PayPalCheckoutRequest = { skipShippingVerification: false },
  ): Promise<Result<PayPalCheckoutResponse>> {
    /**
     * login-true
     * shipping-options/payment=false
     */
    const url = `/shoppingCart/paymentMethod/payPal/checkout?skipShippingVerification=${request.skipShippingVerification}`;

    const res = await this.apiClient.put(url);
    const json = await res.json();


    return new Result(json);
  }

  public async paypalAuthorize(request: PayPalAuthorizeRequest): Promise<EmptyResult> {
    /**
     * login-true
     * shipping-options/payment=false
     */
    const url = `/shoppingCart/paymentMethod/payPal/authorize?orderId=${encodeURIComponent(
      request.orderId,
    )}&skipShippingVerification=${request.skipShippingVerification}`;

    const { skipShippingVerification, ...body } = request;

    await this.apiClient.put(url, {
      body,
    });


    return new EmptyResult();
  }
}
